// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.entityTable__toolbar {
    justify-content: space-between;
}

.entityTable__toolbar > button {
    margin: 0 4px;
}
.entityTable__toolbar__actions {
    position: relative;
    flex: 1;
    display: flex;
    flex-wrap: wrap;
}
.entityTable__toolbar__placeholder {
    display: inline-flex;
}

.entityTable__toolbar__pagination,
.entityTable__toolbar__pagination-empty {
    flex: 1;
    min-width: fit-content;
    min-height: 0px;
}

.entityTable__toolbar__pagination-empty {
    height: 52px;
}

.entityTable__toolbar__title {
    text-align: center;
    font-size: 1.3rem;
    flex: 1;
}

.entityTable__lookupCell {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 0 16px;
}
.entityTable__linkCell,
.entityTable__applicationStatusCell,
.entityTable__deadlineDateCell {
    overflow: hidden;
    word-wrap: break-word;
}

/* colors start */
.entityTable__row--error {
    background-color: rgba(231, 77, 60, 0.4);
}
.entityTable__row--error:hover:not(.Mui-selected) {
    background-color: #e74d3c99 !important;
}
.entityTable__cell-text--error {
    color: #e74c3c;
}
.entityTable__row--red {
    background-color: hsla(6, 100%, 88%, 0.5);
}
.entityTable__row--red:hover:not(.Mui-selected) {
    background-color: hsl(6, 95%, 85%) !important;
}
.entityTable__row--orange {
    background-color: hsla(31, 100%, 92%, 0.5);
}
.entityTable__row--orange:hover:not(.Mui-selected) {
    background-color: #fadcbc;
}
.entityTable__row--gray {
    background-color: #eee;
}
.entityTable__row--gray:hover:not(.Mui-selected) {
    background-color: #bebebe;
}
.entityTable__row--purple {
    background-color: hsla(272, 60%, 74%, 0.5);
}
.entityTable__row--purple:hover:not(.Mui-selected) {
    background-color: #b57edc;
}
.entityTable__row--blue {
    background-color: hsla(202, 76%, 80%, 0.5);
}
.entityTable__row--blue:hover:not(.Mui-selected) {
    background-color: #4cb9fa;
}
.entityTable__row--green {
    background-color: hsla(165, 53%, 68%, 0.5);
}
.entityTable__row--green:hover:not(.Mui-selected) {
    background-color: #6cceb5;
}

.entityTable__cell--strikethrough {
    position: relative;
}

.entityTable__cell--strikethrough::after {
    content: "";
    position: absolute;
    top: 50%;
    left: 0;
    width: 100%;
    height: 1px;
    background-color: black; /* Change color as needed */
    /* transform: translateY(-50%); */
}

/* colors legend  */
.entityTable__legend--red {
    color: #ff2c15;
}
.entityTable__legend--orange {
    color: #ff9320;
}
.entityTable__legend--gray {
    color: #eee;
}
.entityTable__legend--purple {
    color: #9b28ff;
}
.entityTable__legend--blue {
    color: #a5d6f3;
}
.entityTable__legend--green {
    color: #118a6b;
}
/* colors end */
`, "",{"version":3,"sources":["webpack://./../mirage/src/components/entityTable/EntityTable.css"],"names":[],"mappings":"AAAA;IACI,8BAA8B;AAClC;;AAEA;IACI,aAAa;AACjB;AACA;IACI,kBAAkB;IAClB,OAAO;IACP,aAAa;IACb,eAAe;AACnB;AACA;IACI,oBAAoB;AACxB;;AAEA;;IAEI,OAAO;IACP,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,OAAO;AACX;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,cAAc;AAClB;AACA;;;IAGI,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA,iBAAiB;AACjB;IACI,wCAAwC;AAC5C;AACA;IACI,sCAAsC;AAC1C;AACA;IACI,cAAc;AAClB;AACA;IACI,yCAAyC;AAC7C;AACA;IACI,6CAA6C;AACjD;AACA;IACI,0CAA0C;AAC9C;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,0CAA0C;AAC9C;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,0CAA0C;AAC9C;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,0CAA0C;AAC9C;AACA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,OAAO;IACP,WAAW;IACX,WAAW;IACX,uBAAuB,EAAE,2BAA2B;IACpD,iCAAiC;AACrC;;AAEA,mBAAmB;AACnB;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,WAAW;AACf;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA,eAAe","sourcesContent":[".entityTable__toolbar {\n    justify-content: space-between;\n}\n\n.entityTable__toolbar > button {\n    margin: 0 4px;\n}\n.entityTable__toolbar__actions {\n    position: relative;\n    flex: 1;\n    display: flex;\n    flex-wrap: wrap;\n}\n.entityTable__toolbar__placeholder {\n    display: inline-flex;\n}\n\n.entityTable__toolbar__pagination,\n.entityTable__toolbar__pagination-empty {\n    flex: 1;\n    min-width: fit-content;\n    min-height: 0px;\n}\n\n.entityTable__toolbar__pagination-empty {\n    height: 52px;\n}\n\n.entityTable__toolbar__title {\n    text-align: center;\n    font-size: 1.3rem;\n    flex: 1;\n}\n\n.entityTable__lookupCell {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin: 0 16px;\n}\n.entityTable__linkCell,\n.entityTable__applicationStatusCell,\n.entityTable__deadlineDateCell {\n    overflow: hidden;\n    word-wrap: break-word;\n}\n\n/* colors start */\n.entityTable__row--error {\n    background-color: rgba(231, 77, 60, 0.4);\n}\n.entityTable__row--error:hover:not(.Mui-selected) {\n    background-color: #e74d3c99 !important;\n}\n.entityTable__cell-text--error {\n    color: #e74c3c;\n}\n.entityTable__row--red {\n    background-color: hsla(6, 100%, 88%, 0.5);\n}\n.entityTable__row--red:hover:not(.Mui-selected) {\n    background-color: hsl(6, 95%, 85%) !important;\n}\n.entityTable__row--orange {\n    background-color: hsla(31, 100%, 92%, 0.5);\n}\n.entityTable__row--orange:hover:not(.Mui-selected) {\n    background-color: #fadcbc;\n}\n.entityTable__row--gray {\n    background-color: #eee;\n}\n.entityTable__row--gray:hover:not(.Mui-selected) {\n    background-color: #bebebe;\n}\n.entityTable__row--purple {\n    background-color: hsla(272, 60%, 74%, 0.5);\n}\n.entityTable__row--purple:hover:not(.Mui-selected) {\n    background-color: #b57edc;\n}\n.entityTable__row--blue {\n    background-color: hsla(202, 76%, 80%, 0.5);\n}\n.entityTable__row--blue:hover:not(.Mui-selected) {\n    background-color: #4cb9fa;\n}\n.entityTable__row--green {\n    background-color: hsla(165, 53%, 68%, 0.5);\n}\n.entityTable__row--green:hover:not(.Mui-selected) {\n    background-color: #6cceb5;\n}\n\n.entityTable__cell--strikethrough {\n    position: relative;\n}\n\n.entityTable__cell--strikethrough::after {\n    content: \"\";\n    position: absolute;\n    top: 50%;\n    left: 0;\n    width: 100%;\n    height: 1px;\n    background-color: black; /* Change color as needed */\n    /* transform: translateY(-50%); */\n}\n\n/* colors legend  */\n.entityTable__legend--red {\n    color: #ff2c15;\n}\n.entityTable__legend--orange {\n    color: #ff9320;\n}\n.entityTable__legend--gray {\n    color: #eee;\n}\n.entityTable__legend--purple {\n    color: #9b28ff;\n}\n.entityTable__legend--blue {\n    color: #a5d6f3;\n}\n.entityTable__legend--green {\n    color: #118a6b;\n}\n/* colors end */\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
